<div class="receive-wrapper">
  <img ngSrc="assets/logo.png" alt="logo" width="30" height="30" class="logo" [class.rotate]="useLoading"/>
  <div class="receive-bubble">
    @if (usedPapers.length > 0) {
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>quick_reference</mat-icon>
              Sources
            </mat-panel-title>
          </mat-expansion-panel-header>
          @for (paper of usedPapers; track $index) {
            <app-research-paper-card [paper]="paper" [editable]="false"></app-research-paper-card>
          }
        </mat-expansion-panel>
      </mat-accordion>
    }
    @if (messageText) {
      <app-sourced-markdown
        [isSmallScreen]="isSmallScreen()"
        [markdown]="messageText"
        [papers]="papers() || []"
      ></app-sourced-markdown>
    }
  </div>
</div>
